module.exports = __webpack_public_path__ + "img/summary.ebcad8cb.svg";